import { Box, Icon, IconButton } from '@mui/material'
import React from 'react'

import Logo from '@/app/component/atom/logo'
import { Organization, SelectOption } from '@/app/types'

import CATIMobileDrawer from './cati-mobile-drawer'
import { Content, Right, StyledLink } from './common'

type Props = {
  activeOrg?: Organization
  email: string
  organizations?: SelectOption<number>[]
  isAuthorized: boolean
  hasOrg: boolean
  mobileMenuOpen: boolean
  onToggleMobileNav: () => void
  logout: () => void
  onOrgSelect: (org: SelectOption<number>) => void
}

const CATIMobileHeader: React.FC<Props> = ({
  activeOrg,
  email,
  organizations = [],
  isAuthorized,
  hasOrg,
  mobileMenuOpen,
  onToggleMobileNav,
  logout,
  onOrgSelect,
}) => (
  <>
    {isAuthorized && (
      <Box sx={{ mr: 1 }}>
        <IconButton data-testid="nav-mobile-toggle" color="inherit" onClick={onToggleMobileNav}>
          <Icon>dehaze</Icon>
        </IconButton>
      </Box>
    )}
    <StyledLink to="/">
      <Logo />
    </StyledLink>
    <Content>
      {hasOrg && (
        <CATIMobileDrawer
          open={mobileMenuOpen}
          onClose={onToggleMobileNav}
          hasOrg={hasOrg}
          activeOrg={activeOrg}
          organizations={organizations}
          email={email}
          logout={logout}
          onOrgSelect={onOrgSelect}
        />
      )}
      <Right />
    </Content>
  </>
)

export default CATIMobileHeader
